import script from "./ZiId+GetZiId+GetZiBasic+ClearZiCell.vue?vue&type=script&setup=true&lang=js"
export * from "./ZiId+GetZiId+GetZiBasic+ClearZiCell.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__